import { Circle, Placemark } from '@pbe/react-yandex-maps'
import React, { FC, useState } from 'react'
import {
  balloonCluster,
  balloonDtp,
} from '@/components/Organisms/Map/balloonsDtp'
import { getColorUnit } from '@/components/Organisms/Map/MapDTP'
import { UnitsMapType } from '@/modules/maps/types/unitsMapType'
import { useGetDetailUnitMutation } from '@/modules/maps/services/homeMapService'

interface Props {
  unit: any
  zoomState?: number
  unitTotal: number
}

const createCircleIcon = (color: string, size = 15, opacity = 1): string => {
  const svg = `
    <svg width="${size}" height="${size}" xmlns="http://www.w3.org/2000/svg">
      <circle cx="${size / 2}" cy="${size / 2}" r="${size / 2 - 1}" fill="${color}" fill-opacity="${opacity}" stroke="white" stroke-width="1"/>
    </svg>
  `
  return `data:image/svg+xml;base64,${btoa(unescape(encodeURIComponent(svg)))}`
}

const DtpPlacemark: FC<Props> = ({ unit, zoomState, unitTotal }) => {
  if (zoomState && unitTotal > 100 && zoomState <= 11) return null
  const [getDetailUnit] = useGetDetailUnitMutation()
  const onLoadData = async (id: number) => {
    try {
      const data = await getDetailUnit(id).unwrap()
      setBalloonData(data)
    } catch (e) {
      console.error(e)
    }
  }
  const [balloonData, setBalloonData] = useState<any>(null)
  return (
    <Placemark
      key={unit.id}
      defaultGeometry={unit.coordinates}
      onBalloonOpen={() => onLoadData(unit.id)}
      onBaloonClose={() => setBalloonData(null)}
      options={{
        iconLayout: 'default#image',
        iconImageHref: createCircleIcon(getColorUnit(unit.severityTypeId), 10),
        iconImageSize: [15, 15],
        iconImageOffset: [-7.5, -7.5],
        hideIconOnBalloonOpen: false,
      }}
      properties={{
        balloonContentBody: balloonDtp(false, false, balloonData),
      }}
    />
  )
}

export default DtpPlacemark
